import React from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { NewsGridCard } from "@modules/study/common/news";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "./top_section.module.scss";

function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <FiChevronRight
      className={`${className} NewsSliderNext`}
      onClick={onClick}
    />
  );
}

function PrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <FiChevronLeft
      className={`${className} NewsSliderPrev`}
      onClick={onClick}
    />
  );
}

export const NewsTopSection = ({ breakingNews, topStories }) => {
  let breakingNewsCount = "";
  if (breakingNews?.length < 3) {
    breakingNewsCount = breakingNews?.length;
  } else {
    breakingNewsCount = 3;
  }

  const settings = {
    dots: false,
    arrows: true,
    className: "BreakingNewsSlider",
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 1000,
    slidesToShow: breakingNewsCount,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          arrows: true,
          centerMode: false,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          arrows: true,
          dots: false,
          centerMode: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className={styles.top_section}>
      <div className="container">
        {breakingNews && breakingNews?.length > 0 && (
          <div className={styles.carousel_news_wrapper_container}>
            <h4 className={styles.carousel_news_heading}>Breaking News</h4>
            <div className={styles.carousel_news_wrapper}>
              <Slider {...settings}>
                {breakingNews &&
                  breakingNews?.map((news, i) => {
                    return (
                      <NewsGridCard
                        key={news?.newsId}
                        showAuthor={false}
                        showImage={false}
                        data={news}
                        customClasses={{
                          cardClass: styles.news_card_breaking,
                          titleClass: styles.news_card_breaking_title,
                        }}
                      />
                    );
                  })}
              </Slider>
            </div>
          </div>
        )}

        {topStories && topStories?.length > 0 && (
          <div className={styles.top_stories_wrapper}>
            <div className={styles.title_wrapper}>
              <h4 className={styles.title}>Top Stories</h4>
            </div>
            <div className={styles.news_card_wrapper}>
              {topStories?.map((post, i) => {
                return (
                  <NewsGridCard
                    key={i}
                    data={post}
                    showDescription={i === 0}
                    customClasses={{
                      cardClass: styles.news_card,
                      titleClass: styles.news_card_title,
                      featureImageClass: styles.news_feature_image_wrapper,
                    }}
                  />
                );
              })}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default NewsTopSection;
